import type { ReactNode } from 'react'
import styles from './FormField.module.scss'

export interface FormFieldLabelProps {
  label: string
  required?: boolean
}

export function FormFieldLabel({ label, required }: FormFieldLabelProps): ReactNode {
  return (
    <>
      <span className={styles.label}>{label}</span>
      {required && <span className={styles.required}>*</span>}
    </>
  )
}
